import { render, staticRenderFns } from "./fhydph.vue?vue&type=template&id=0c7c8d49&scoped=true"
import script from "./fhydph.vue?vue&type=script&lang=js"
export * from "./fhydph.vue?vue&type=script&lang=js"
import style0 from "./fhydph.vue?vue&type=style&index=0&id=0c7c8d49&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7c8d49",
  null
  
)

export default component.exports